import Vue from 'vue'
import App from './App.vue'
import {router} from './router.js'

// Plugins
import vuetify from './plugins/vuetify';
import './plugins/vuemask'

// Libraries
import './lib/axios.js'

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
